export const routePaths = {
    MOBILE: '/mobile',
    ORDINI_DI_SPEDIZIONE: '/mobile/ordini-di-spedizione',
    ORDINI_DI_SPEDIZIONE_ID: '/mobile/ordini-di-spedizione/:id',
    SIM: '/mobile/sim',
    ASSISTENZA: '/mobile/assistenza',
    REPORT: '/mobile/report',
    DEVICE: '/mobile/device',
    MANUALE: '/mobile/manuale',
    EXTRA_SHARE: '/mobile/extra-share',
    EXTRA_SHARE_BULK_ID: '/mobile/extra-share/:bulkId',
    THRESHOLD_EVENTS: '/mobile/threshold-events',
    CONTRATTO_DIGITALE: '/mobile/contratto-digitale',
    CONTRATTO_DIGITALE_DETAILS: '/mobile/contratto-digitale/:digitalContractId',
    ORDINI_CONSIP_TM9: '/mobile/ordini-consip-tm9',
    ORDINI_CONSIP_DETAILS: '/mobile/ordini-consip-tm9/:consipId',
    ESIM: '/mobile/e-sim',
    ESIM_INVIO_EMAIL: '/mobile/e-sim/esito-invio-email',
    ESIM_PARAMETRI: '/mobile/e-sim/parametri',
    RESTITUZIONI_DETAILS: "/mobile/device/restituzioni/:nOrdineReso",
    ESIM_FORMAT_CHANGE: '/mobile/e-sim/format-change'
}
